import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { Grid, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomDiv from "../../../Shared/CustomDiv";
import Text from "../../../Shared/Text";
import { IconButton } from "@mui/joy";
import axiosInstance from "../../../Config/axios";
import { API_URLS } from "../../../Config/API_URLS";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { categoryListFn } from "../../../Services/CategoryList";
import { allFiltersFn } from "../../../Services/AllFilters/index,";
import { productsFn } from "../../../Services/Products";
import { sortByFn } from "../../../Services/SortBy";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import classNames from "classnames";
import pen from "../../../images/pen.svg";

const AllProducts = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const client = useQueryClient();

  const { state } = useLocation();

  const handleChange = (event, value) => {
    setPage(value);
  };

  const { mutate, isLoading } = useMutation(productsFn, {
    onSuccess: (response) => {
      setData(response.data.data.product_list);
      setCount(response.data.total_pages);
    },
  });

  const { mutate: filter, isLoading: isLoading2 } = useMutation(sortByFn, {
    onSuccess: (response) => {
      setData(response.data.data.product_list);
      setCount(0);
    },
  });

  const { mutate: allFilters, isLoading: isLoading1 } = useMutation(
    allFiltersFn,
    {
      onSuccess: (response) => {
        setData(response.data.data.product_list);
        setCount(response.data.total_pages);
      },
    }
  );

  const handleLogin = (event) => {
    event.stopPropagation();
    dispatch(setThemeMode(true));
  };
  useEffect(
    () => {
      if (state?.from === "sortby")
        filter({
          sort_by:
            state?.sortby !== "price_low_to_high" &&
              state?.sortby !== "price_high_to_low"
              ? state?.sortby
              : "None",
          price_low_to_high:
            state?.sortby === "price_low_to_high"
              ? "price_low_to_high"
              : "None",
          price_high_to_low:
            state?.sortby === "price_high_to_low"
              ? "price_high_to_low"
              : "None",
        });
    },
    // eslint-disable-next-line
    [state?.from, state?.sortby]
  );
  useEffect(
    () => {
      if (state?.from === "search")
        filter({
          search: state?.search,
        });
    },
    // eslint-disable-next-line
    [state?.search, state?.from]
  );
  useEffect(
    () => {
      if (state?.from === "allproduct") mutate({ page: page });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    // eslint-disable-next-line
    [state?.from, page]
  );
  useEffect(
    () => {
      if (state?.from === "subCategory")
        allFilters({
          page: page,
          category_id: "",
          sub_category_id: state?.subCategory,
          brand_id: "",
          color_id: "",
          max_price: "",
          min_price: "",
          rating: "",
        });
    },
    // eslint-disable-next-line
    [state?.from, state?.subCategory, page]
  );

  useEffect(
    () => {
      if (state?.from === "category")
        allFilters({
          page: page,
          category_id: state?.category,
          sub_category_id: "",
          brand_id: "",
          color_id: "",
          max_price: "",
          min_price: "",
          rating: "",
        });
    },
    // eslint-disable-next-line
    [state?.from, state?.category, page]
  );
  useEffect(
    () => {
      if (state?.from === "priceRange")
        allFilters({
          page: page,
          category_id: "",
          sub_category_id: "",
          brand_id: "",
          color_id: "",
          rating: "",
          min_price:
            state?.priceRange === "2"
              ? 0
              : state?.priceRange === "3"
                ? 100
                : state?.priceRange === "4"
                  ? 200
                  : state?.priceRange === "5"
                    ? 500
                    : "",
          max_price:
            state?.priceRange === "2"
              ? 100
              : state?.priceRange === "3"
                ? 200
                : state?.priceRange === "4"
                  ? 500
                  : state?.priceRange === "5"
                    ? 100000
                    : "",
        });
    },
    // eslint-disable-next-line
    [state?.from, state?.priceRange, page]
  );

  const handleWishList = (variant_id, event) => {
    event.stopPropagation();
    const reqBody = {
      add_quantity: 1,
      product_id: variant_id,
    };

    axiosInstance
      .post(API_URLS.addToWishList, reqBody)
      .then((response) => {
        client.refetchQueries("wishList");
        response.data.msg === "Data get Successfully"
          ? mutate({ page: page })
          : response.data.msg === "Something Wrong with the quanity !"
            ? enqueueSnackbar("Product is Out-of-Stock", { variant: "error" })
            : enqueueSnackbar(response.data.msg, { variant: "error" });
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const { data: mainCategoryList } = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return (
    <CustomDiv className="bg-gray-100  flex lg:flex-row flex-col justify-between lg:gap-5  shadow px-[3%] lg:px-[8%] lg:py-[2%] py-[5%] w-full">
      <CustomDiv className="flex flex-col lg:w-full">
        {isLoading1 || isLoading || isLoading2 ? (
          <Grid className="grid grid-cols-2 gap-8 lg:grid-cols-3 2xl:grid-cols-3 hide-scroll md:grid-cols-3 lg:gap-4 ">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((product) => {
              return (
                <div className="rounded-3xl h-auto lg:w-[250px] w-full lg:hover:scale-[1.02] transition-transform duration-200 shadow bg-white cursor-pointer ">
                  <div className="h-40 bg-gray-300 lg:h-52"></div>
                  <div className="flex flex-col gap-3 px-4 py-8 space-y-4 sm:p-8 bg-gray-50">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-3/4 h-6 bg-gray-300"></div>
                  </div>
                </div>
              );
            })}
          </Grid>
        ) : (
          <div className="mt-10 mb-10 pr11">
            {data?.map((product) => {
              return (
                <>
                  <div className="justify-center grid-cols-3 pr12 lg:grid lg:gap-10">
                    <div className="pr13 background background1 "></div>
                    <div
                      className=" pr14 card"
                      onClick={() => navigate(`/product/${product?.id}`)}
                    >
                      <span className=" centerdiv">
                        <img
                          src={product.image}
                          alt=""
                          className="relative h-24"
                        />
                      </span>
                      <CustomDiv className="flex flex-col justify-between p-2 space-y-2 lg:p-4">
                        <CustomDiv className="space-y-2">
                          <Text className="w-40 overflow-hidden font-semibold lg:text-lg lg:block lg:w-48 whitespace-nowrap text-ellipsis">
                            {product.variant_name}
                          </Text>
                        </CustomDiv>
                        <Text className="text-sm text-green-600 uppercase">
                          {product.main_category}
                        </Text>
                        <Text
                          className={classNames(
                            "text-xs  uppercase",
                            product.stock_sataus === "In-stock"
                              ? "text-gray-600"
                              : "text-red-600"
                          )}
                        >
                          {product.stock_sataus === "In-stock"
                            ? "In-Stock"
                            : "Out-Of-Stock"}
                        </Text>
                        <CustomDiv className="flex items-center gap-2">
                          <Text className="text-xs line-through lg:text-base">
                            {product.discount_percent !== "0.0"
                              ? `₹${product.price}`
                              : null}
                          </Text>
                          <Text className="text-sm font-bold lg:text-xl">
                            ₹{product.actual_price}
                          </Text>
                          <Text className="text-xs text-green-600 lg:text-base">
                            {product.discount_percent !== "0.0"
                              ? `(${product.discount_percent?.split(".0")})%`
                              : null}
                          </Text>
                        </CustomDiv>
                        <span className="flex lg:gap-2">
                          <IconButton
                            color="primary"
                            variant="solid"
                            onClick={(event) => {
                              localStorage.getItem("token") ? (
                                product.whishlist_status === "yes" ? (
                                  <>{` ${enqueueSnackbar(
                                    "Product is already in wishlist"
                                  )}
                            ${event.stopPropagation()}`}</>
                                ) : (
                                  handleWishList(product?.variant_id, event)
                                )
                              ) : (
                                handleLogin(event)
                              );
                            }}
                            className="!rounded !bg-[#306BDE] scale-90 lg:scale-100"
                          >
                            {product.whishlist_status === "yes" ? (
                              <Favorite />
                            ) : (
                              <FavoriteBorder />
                            )}
                          </IconButton>

                          <button
                            className="pr23"
                            onClick={() => navigate(`/product/${product?.id}`)}
                          >
                            <div className="pr24 ">
                              <div className="pr25">
                                <img alt="" src={pen} className="pt-5" />
                              </div>
                            </div>
                            <div className="pr27">
                              <p className="pr28">See More</p>
                              <p className="pr29"></p>
                            </div>
                          </button>
                        </span>
                      </CustomDiv>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        )}

        <span className="flex items-center justify-between w-full my-3">
          {count <= 1 ? null : (
            <Pagination
              count={count}
              page={page}
              onChange={handleChange}
              variant="outlined"
              shape="rounded"
              color="primary"
              className="w-full"
            />
          )}
        </span>
      </CustomDiv>
    </CustomDiv>
  );
};

export default AllProducts;
